<script>
    import { DialogNew } from "@shopboxai/sb-portal-components";
    import { notifications } from "@shopboxai/sb-portal-components";

    export let data;

    const handleSubmit = () => {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(data.token);
            notifications.success("API Token copied", 2000);
        }
    };
</script>

<DialogNew on:submit={handleSubmit}>
    <button class="secondary" slot="toggle">show</button>
    <div slot="header">API key</div>
    <div slot="content">
        <textarea rows="7" readonly>
            {data.token}
        </textarea>
    </div>
    <button class="primary" slot="primary-action"> Copy </button>
</DialogNew>

<style>textarea{border:0;resize:none;width:100%}.secondary{background:none;border:none;color:#3a4bc4;cursor:pointer;font-size:14px;font-weight:400;letter-spacing:.4px;line-height:18px;-webkit-text-decoration-line:underline;text-decoration-line:underline}</style>
